// Consultation/UserConsultationRoleCard.tsx

import React, {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import UserAvatar from 'User/UserAvatar';
import {IConsultation} from '../../Types/psychology/consultation';
import {useTheme} from 'Theme/ThemeContext';
import {FCCS, FRSC} from 'WideLayout/Layouts';
import PsychologistItem from "Psychologist/PsychologistItem";
import {AuthContext, AuthContextType} from "Auth/AuthContext";

interface UserConsultationRoleCardProps {
    user: IConsultation['clients'][0] | IConsultation['psychologists'][0];
    role: 'клиент' | 'психолог';
    sizeRem?: number;
}

const UserConsultationRoleCard: React.FC<UserConsultationRoleCardProps> = (
    {user: userProp, role, sizeRem = 3}) => {
    const navigate = useNavigate();
    const {plt} = useTheme();

    const {user} = useContext(AuthContext) as AuthContextType;
    return (
        <FRSC
            flexWrap="wrap"
            sx={{gap: '0.6rem', cursor: 'pointer'}}
            onClick={() => {
                // Navigate to profile if it's the current user, else to the user's profile page
                // Assuming `user` has an `id` and `avatar` property
                // You'll need access to the current user's ID to compare
                // For simplicity, let's assume a prop or context provides `currentUserId`
                // Here, I'll omit that and assume navigation based on user ID
                // You can adjust this logic as per your application's context
                if (user?.id === userProp.id) {
                    navigate('/profile');
                    return;
                }
                navigate(role === 'клиент' ? `/clients/${userProp.id}` : `/psychologists/${userProp.id}`)  // Replace with actual route paths based on your application's routing setup');
            }}>
            {role === 'клиент' ?
                <UserAvatar
                    avatar={userProp.avatar}
                    size={`${sizeRem}rem`}
                    zIndex={2}
                    sx={{position: 'absolute', top: 0, left: 0}}
                />
                : userProp.psychologist
                    ?
                    <PsychologistItem
                        sizeRem={sizeRem}
                        isActive={false}
                        showChatButton={true}
                        showName={false}
                        chatButtonSize={'.9rem'}
                        psychologist={userProp.psychologist}/>
                    : null}

            <FCCS g={'.1rem'}>
                <span className="fs-5" style={{
                    color: plt.text.primary65,
                    lineHeight: '1rem'
                }}>
                    {`${userProp.first_name} ${userProp.last_name}`}
                </span>
                <span className="ps-1px fs-6 fw-3"
                      style={{
                          color: plt.text.primary45,
                          lineHeight: '1rem'
                      }}>
                    {role}
                </span>
            </FCCS>
        </FRSC>
    );
};

export default UserConsultationRoleCard;
